import {Component, OnDestroy, OnInit} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, Validators } from '@angular/forms';
import {  NzModalService } from 'ng-zorro-antd/modal';
import { ValidateService } from 'src/app/modules/product/services/validate.service';
import { MasterDataProductService } from 'src/app/modules/product/services/master-data-product.service';
import { TranslateService } from '@ngx-translate/core';
import { ProductService } from '../../product.service';
import { DataService } from '../../services/data.service';
import { forkJoin, of, Subscription } from 'rxjs';
import { map, filter } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { EventManager } from 'src/app/core';
import { CreateProduct } from '../edit-fund/create-product';
import { Gold } from '../../models/gold.model';
import { CommonFunction } from '../edit-fund/common.function';
import { FileUploader } from 'ng2-file-upload';
import { UploaderService } from 'src/app/shared/services/uploader.service';
import { environment } from 'src/environments/environment';
import { Constant } from 'src/app/core/constant';
declare let $: any;
@Component({
  selector: 'app-edit-gold',
  templateUrl: './edit-gold.component.html',
  styleUrls: ['./edit-gold.component.scss'],
  providers: [ValidateService, DataService],
})
export class EditGoldComponent extends CreateProduct implements OnInit, OnDestroy {
  id: number;
  gold: Gold = new Gold();
  isTest: boolean = true;
  subscriptions: Subscription[] = [];
  types: any[] = [];
  isApproved: boolean = false;
  initialProduct: any;
  isCalling: boolean = false;
  uploader: FileUploader;
  editForm = this.formBuilder.group({
    name: ['', [Validators.required]],
    nameEn: ['', [Validators.required]],
    shortName: ['', [Validators.required]],
    code: ['', [Validators.required]],
    goldTypeCode: ['', [Validators.required]],
    imageUrl: ['', [Validators.required]],
    buyValue: [0],
    sellValue: [0],
    keepingFee: ['', [Validators.required]],
    goldUnit: [''],
    buyLimitSession: [undefined],
    buyLimitDaily: [undefined],
    sellLimitSession: [undefined],
    sellLimitDaily: [undefined],
    description: [''],
    descriptionEn: [''],
  });
  constructor(
      public formBuilder: FormBuilder,
      public router: Router,
      public route: ActivatedRoute,
      public validateService: ValidateService,
      public productService: ProductService,
      public dataService: DataService,
      translate: TranslateService,
      public masterDataProductService: MasterDataProductService,
      public toastrService: ToastrService,
      private eventManager: EventManager,
      private uploaderService: UploaderService,
      public modalService: NzModalService
  ) {
    super(dataService);
    translate.addLangs(['en_US', 'vi_VN']);
    translate.use('vi_VN');
  }
  ngOnInit() {
    const path = this.route.snapshot.routeConfig.path;
    if (path.includes('approve')) {
      this.isApproved = true;
    }
    this.type = this.Constant.CODE_GOLD;
    this.tab = this.Constant.CODE_GOLD;
    this.subscriptions = [
      this.editForm.get('code').valueChanges.subscribe(
        val => {
          if (this.editForm.value.code !== val) {
            setTimeout(() => {
              this.editForm.patchValue({
                code:  CommonFunction.removeDiacritics((val || '').toUpperCase())
              })
            }, 100)
          }
        }
      ),
      this.eventManager.subscribe('upload-image-gold', (res) => {
        setTimeout(() => {})
        this.editForm.patchValue({
          imageUrl:  res.content.imagePath,
        })
      }),
    ];
    this.getMasterData();
    this.uploader = this.uploaderService.initUploader(
      environment.urlUploadBackEnd + Constant.API_UPLOAD, 'upload-image-gold');
  }
  ngOnDestroy() {
    this.eventManager.destroys(this.subscriptions);
  }
  getMasterData() {
    forkJoin(
      this.getFundType(),
    )
    .subscribe((results) => {
        this.complete(results);
    });
  }
  getFundType() {
    return this.productService.queryGoldType()
    .pipe(map((res: any) => {
      this.types = res.data || [];
      return res;
    }));
  }
  complete(array) {
    const params = this.route.snapshot.params;
    this.id = params.id;
    if (this.id) {
      this.getDetail();
    }
    this.getResource();
  }
  getDetail() {
    this.productService
      .find(this.id)
      .subscribe(
        (res: any) => {
          const product = res.body.data;
          this.gold = new Gold(product);
          this.updateForm();
        }
      );
  }
  updateForm() {
    const productGold = this.gold.productGold || {};
    const goldType =this.types.find(item => item.goldId === productGold.goldTypeCode) || {};
    this.editForm.patchValue({
      name: this.gold.name,
      nameEn: this.gold.nameEn,
      shortName: this.gold.shortName,
      code: this.gold.code,
      goldTypeCode: productGold.goldTypeCode,
      imageUrl: productGold.imageUrl,
      buyValue: goldType.rateBuy,
      sellValue: goldType.rateSell,
      description: this.gold.description,
      descriptionEn: this.gold.descriptionEn,
      keepingFee: productGold.keepingFee,
      goldUnit: (productGold.goldUnit || []).join(','),
      buyLimitSession: productGold.buyLimitSession,
      buyLimitDaily: productGold.buyLimitDaily,
      sellLimitSession: productGold.sellLimitSession,
      sellLimitDaily: productGold.sellLimitDaily,
    })
  }
  disabledButton() {
    let result = false;
    return result;
  }
  save() {
    this.isValidated = true;
    if (this.editForm.invalid || this.disabledButton()) {
      return;
    }
    const body = {
      id: this.gold.id,
      name: (this.editForm.value.name || '').trim(),
      nameEn: (this.editForm.value.nameEn || '').trim(),
      shortName: (this.editForm.value.shortName || '').trim(),
      code: (this.editForm.value.code || '').trim(),
      goldTypeCode: (this.editForm.value.goldTypeCode || '').trim(),
      imageUrl: (this.editForm.value.imageUrl || '').trim(),
      description: (this.editForm.value.description || '').trim(),
      descriptionEn: (this.editForm.value.descriptionEn || '').trim(),
      goldUnit: (this.editForm.get('goldUnit').value || '').trim(),
      keepingFee: this.editForm.get('keepingFee').value,
      buyLimitSession: this.editForm.get('buyLimitSession').value,
      buyLimitDaily: this.editForm.get('buyLimitDaily').value,
      sellLimitSession: this.editForm.get('sellLimitSession').value,
      sellLimitDaily: this.editForm.get('sellLimitDaily').value,
    }
    return this.productService.update(body)
    .subscribe((res: any) => {
      this.toastrService.success('Edit Gold Successfully!');
        this.router.navigate(['/products/gold']);
    });
  }
  approve() {
    if (this.isCalling) {
      return;
    }
    this.isCalling = true;
    this.productService.approve(this.id, {})
    .subscribe(
      (res: any) => {
        this.toastrService.success('Approve Gold Successfully!');
        this.router.navigate(['/products/gold']);
      }
    )
  }
}
